/* eslint-disable */
export default {
    billing_all_projects: "All projects",
    billing_select_organisation_first: "Select an organisation or date range first",
    billing_no_results: "No results",
    billing_table_organisation: "Organisation",
    billing_table_project: "Project",
    billing_table_name: "Name",
    billing_table_email: "E-mail",
    billing_table_completion_date: "Completed",
    billing_table_product_name: "Product",
    billing_table_title: "Billing",
    billing_export: "Export",
    billing_all_products: "All products",
    billing_general_error: "An error occurred while processing your request. Please try again.",
    billing_fetching_results: "Fetching results, please wait",
    billing_selected: "selected",
    billing_mark_as_billed_confirm_title: "Mark participants as billed",
    billing_mark_as_billed_confirm: "Confirm",
    billing_mark_as_billed_cancel: "Cancel",
    billing_mark_as_billed_modal_text_a: "invoices will be marked as billed.",
    billing_mark_as_billed_modal_text_b: "The billing date is",
    billing_mark_as_billed_modal_text_c: "Are you sure you want to bill these Invoices?",
    billing_mark_as_billed_general_error: "Something went wrong when marking participants as billed. Please try again later.",
    billing_mark_as_billed_success: "The selected participants have been marked as billed.",
    billing_mark_as_unbilled_general_error: "Something went wrong when marking participants as unbilled. Please try again later.",
    billing_mark_as_unbilled_success: "The selected participants have been marked as unbilled.",
    billing_set_participants_billing_state_confirm: "Confirm",
    billing_set_participants_billing_state_cancel: "Cancel",
    billing_set_participants_billing_state_show_billed: "Show billed",
    billing_set_participants_billing_state_billed_date: "Billed",
    billing_set_participants_billing_state_mark_as_billed: "Mark as billed",
    billing_set_participants_billing_state_mark_as_unbilled: "Mark as unbilled",
    billing_mark_as_unbilled_title: "Reset billing date",
    billing_mark_as_billed_title: "Mark as billed",
    billing_mark_as_unbilled_modal_text_a: "The billing date of",
    billing_mark_as_unbilled_modal_text_c: "Are you sure you want to reset these invoices?",
    billing_mark_as_unbilled_modal_text_b: "invoices will be reset.",
    billing_set_participants_billing_state_show_unbilled: "Show unbilled",
    billing_search_for_organisation: "Search for organisation",
    billing_set_participants_billing_state_show_demo: "Show demo",
    billing_detail_panel_tab_cost_heading: "Cost heading",
    billing_cost_heading_success: "The cost heading was successfully updated",
    billing_cost_heading_error: "Something went wrong while updating the cost heading. Please try again later.",
    billing_cost_heading_title: "Cost heading",
    billing_cost_heading_save: "Save",
    billing_finance_header: "LTP Pricing",
    billing_finance_staffel_header: "Below you see the prices for LTP products for the selected year.",
    billing_finance_unit_header: "Below you see the prices for LTP products per unit.",
    billing_finance_no_pricing_available: "No pricing information available",
    billing_finance_table_product: "Product",
    billing_finance_table_per_unit: "Per unit",
    billing_finance_tab_participants: "Participants",
    billing_finance_tab_pricing: "Pricing",
    billing_finance_table_product_building_docks: "Building Docks",
    billing_finance_table_product_talent_fit: "Talent Fit",
    billing_finance_table_product_talent_navigator: "Talent Navigator",
    billing_finance_table_product_pre_fit: "Pre Fit",
    billing_finance_table_product_talent_scan: "Talent Scan",
    billing_detail_panel_tab_api: "API settings",
    billing_detail_panel_api_linked_to: "This organisation is currently linked to AFAS project ",
    billing_finance_table_product_integrity: "Integrity",
    billing_finance_table_product_dealing_with_resistance: "Dealing with resistance",
    billing_finance_table_product_work_safely: "Work safely",
    billing_finance_table_product_derailment: "Gérer la pression",
    billing_table_addon_name: "Add-on",
    billing_error_invalid_date_range: "Invalid date value(s) provided, date range was ignored",
    billing_finance_table_product_phase: "phase",
    billing_finance_table_product_multi_phase: "2-Phase Talent Fit",
    billing_finance_table_product_critical_thinking: "Critical thinking",
    billing_finance_table_product_test_ned: "",
    billing_finance_table_product_test_ned_periodic: "",
    billing_set_participants_billing_state_added_by: "Added by",
    billing_table_price: "Total price",
    billing_finance_table_product_team_and_organisation: "Team & Organisation",
    billing_finance_table_product_compact: "Compact (hybrid)",
    billing_finance_table_product_basic: "Silver",
    billing_finance_table_product_regular: "Extensive assessment (gold)",
    billing_finance_table_product_premium: "Premium assessment (platinum)",
    billing_finance_table_product_c_level: "Executive Assessment",
    billing_finance_table_product_executive: "Compact Executive Assessment",
    billing_finance_table_product_periodic_assessment_test_ned: "Periodic assessment (TestNed)",
    billing_finance_table_product_indication_assessment_test_ned: "Indication assessment (TestNed)",
    billing_finance_table_product_safety: "Safety",
    billing_finance_table_product_employment_assessment_test_ned: "Employment assessment",
    billing_set_filter_participants_button_label: "Filtrer les participants",
    billing_finance_table_product_no_online_scan: "",
    billing_table_item: "Item",
    billing_detail_panel_tab_finance_details: "Finance details",
    billing_detail_panel_tab_finance_details_no_afas_id: "No id available yet",
    billing_detail_panel_price_details_title: "Price details",
    billing_detail_panel_price_details_table_column_item: "Item",
    billing_detail_panel_price_details_table_column_price: "Price",
    billing_detail_panel_price_details_table_column_reason: "Reason",
    billing_detail_panel_price_details_table_column_price_type: "Price type",
    billing_finance_table_product_executive_scan: "Executive Scan",
    billing_detail_panel_price_details_table_price_type_global_price: "Default",
    billing_detail_panel_price_details_table_price_type_org_price: "Organisation",
    billing_detail_panel_price_details_table_price_type_license: "License",
    billing_finance_tab_invoices: "Invoices",
    billing_set_filter_invoices_button_label: "Filter invoices",
    billing_detail_panel_price_details_table_reason_charge: "Charge",
    billing_detail_panel_price_details_table_reason_cancellation: "Cancellation",
    billing_detail_panel_price_details_table_reason_reservation: "Reservation",
    billing_detail_panel_tab_more: "More",
    billing_afas_id_title: "AFAS id",
    billing_afas_project_title: "AFAS project ",
    billing_log_title: "Log",
    billing_participant_files_title: "Dossiers des participants"
};
